<aside class="left-sidebar" data-sidebarbg="skin5">
  <!-- Sidebar scroll-->
  <div class="scroll-sidebar">
    <!-- Sidebar navigation-->
    <nav class="sidebar-nav">
      <ul id="sidebarnav" class="p-t-10">
        <ng-template #navMenu let-NavData>
          <ng-container #sidebar *ngFor="let item of NavData;let last=last">
            <ng-container [ngTemplateOutlet]="item.MenuLink !== '#' ? content : other_content"
              [ngTemplateOutletContext]="{subitem:item}"></ng-container>
          </ng-container>
        </ng-template>

        <ng-template #content let-item='subitem'>
          <li class="sidebar-item">
            <a matRipple class="sidebar-link waves-effect waves-dark sidebar-link" [routerLink]="item.MenuLink"
              aria-expanded="false" (click)="ChangeParentPath($event)">
              <i [class]="item.MenuIcon"></i>
              <span class="hide-menu menu-title">{{item.MenuTitle}}</span>
            </a>
          </li>
        </ng-template>

        <ng-template #other_content let-item='subitem'>
          <li class="sidebar-item">
            <a matRipple class="sidebar-link has-arrow waves-effect waves-dark" href="javascript:void(0)"
              aria-expanded="false" (click)="folderClick(item)">
              <i [class]="'fas ' + (item.Open ? 'fa-folder-open' : 'fa-folder')"></i>
              <span class="hide-menu menu-title">{{item.MenuTitle}}</span></a>
            <ul aria-expanded="false" [class]="'collapse first-level ' + (item.Open ? 'in' : '')"
              *ngIf="item.SubMenu.length > 0">
              <ng-container *ngTemplateOutlet="navMenu; context:{ $implicit: item.SubMenu }">
              </ng-container>
            </ul>
          </li>
        </ng-template>

        <ng-container *ngTemplateOutlet="navMenu; context:{ $implicit: NavigatorData }"></ng-container>
      </ul>
    </nav>
    <!-- End Sidebar navigation -->
  </div>
  <!-- End Sidebar scroll-->
</aside>
